import React, { useEffect, useState } from "react";

/** MUI */
import { makeStyles } from "@mui/styles";

/** Helpers */
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        border: "1px solid #cbd5e0",
        width: "100%",
    },
    container__left: {
        width: "75%",
        overflow: "auto",
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-start",
    },
    resizer: {
        backgroundColor: "transparent",
        cursor: "ew-resize",
        width: 48,
        position: "absolute",
        right: -24,
        top: 12,
        bottom: 12,
        zIndex: 2101,
        opacity: 0.025,
        transition: "opacity 0.25s linear",
        "&:hover": {
            opacity: 1,
        },
        "&:after": {
            content: '" "',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 20,
            height: 48,
            borderRadius: 20,
            background: `#744FAC url('data:image/svg+xml,%3Csvg xmlns="http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" width="24" height="24" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"%3E%3Cpath fill="white" d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2z"%2F%3E%3C%2Fsvg%3E') center center no-repeat`,
        },
    },
    container__right: {
        width: "25%",
        overflow: "auto",
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-start",
    },
    leftChildHolder: {
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-start",
        overflow: "hidden",
    },
    rightChildHolder: {
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-end",
        overflow: "hidden",
    },
    ruller: {
        position: "fixed",
        top: -24,
        // bottom: 0,
        height: "calc(100vh - 144px)",
        width: 1,
        // backgroundColor: "#F00",
        opacity: 0,
        borderLeft: "1px dashed #000",
        "& span": {
            top: "0%",
            transform: "translateX(-50%)",
            position: "absolute",
            padding: "0px 8px",
            backgroundColor: "#FFF",
            borderRadius: 4,
            border: "1px dashed #000",
            fontSize: "0.777777778rem", /*14,*/
            fontWeight: 600,
        },
    },
    rullerLimit: {
        borderLeft: "2px dashed #000",
    },
}));

const LIMITS = {
    min: 300,
    standard: 688,
    max: 888,
};

const Resizer = (props) => {
    const { drawerWidth = LIMITS.standard, onResize } = props;
    // console.log(props);

    const classes = useStyles();

    const [WIDTH, setWIDTH] = useState(drawerWidth);

    /** - resizer */
    useEffect(() => {
        const resizer = document.getElementById("dragMe");
        const ruller = document.getElementById("ruller");

        let x = 0;
        let y = 0;
        let width = drawerWidth;

        const mouseDownHandler = function (e) {
            x = e.clientX;
            y = e.clientY;

            // Attach the listeners to `document`
            document.addEventListener("mousemove", mouseMoveHandler);
            document.addEventListener("mouseup", mouseUpHandler);
        };

        const mouseMoveHandler = function (e) {
            document.body.style.cursor = "col-resize";

            document.body.style.userSelect = "none";
            document.body.style.pointerEvents = "none";

            const _newWidth = e.clientX;

            if (_newWidth >= LIMITS.min && _newWidth <= LIMITS.max) {
                ruller.style.left = `${_newWidth}px`;
                ruller.style.opacity = 1;
                width = _newWidth;
                setWIDTH(width);
            }
        };

        const mouseUpHandler = function () {
            if (width) {
                onResize({ width });
            }

            resizer.style.removeProperty("cursor");
            document.body.style.removeProperty("cursor");
            document.body.style.removeProperty("user-select");
            document.body.style.removeProperty("pointer-events");
            ruller.style.opacity = 0;

            document.selection?.empty();
            window.getSelection()?.removeAllRanges();

            // Remove the handlers of `mousemove` and `mouseup`
            document.removeEventListener("mousemove", mouseMoveHandler);
            document.removeEventListener("mouseup", mouseUpHandler);
        };

        // Attach the handler
        resizer.addEventListener("mousedown", mouseDownHandler);
    }, [drawerWidth]);

    /** Handlers */

    return (
        <>
            <div className={classes.resizer} id={"dragMe"} />
            <div
                className={clsx(
                    classes.ruller,
                    (WIDTH <= LIMITS.min + 1 ||
                        (WIDTH >= LIMITS.standard - 1 && WIDTH <= LIMITS.standard + 1) ||
                        WIDTH >= LIMITS.max - 1) &&
                        classes.rullerLimit
                )}
                id={"ruller"}
            >
                <span>{WIDTH}</span>
            </div>
        </>
    );
};

export default Resizer;
